import { render, staticRenderFns } from "./TeachersView.vue?vue&type=template&id=104d25aa&scoped=true&"
import script from "./TeachersView.vue?vue&type=script&lang=js&"
export * from "./TeachersView.vue?vue&type=script&lang=js&"
import style0 from "./TeachersView.vue?vue&type=style&index=0&id=104d25aa&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "104d25aa",
  null
  
)

export default component.exports